const chunkLoadError = 'ChunkLoadError';

export const ERRORS = {
  chunkLoadError,
};
